import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './app/providers';
import { router } from './app/router';
import { env } from './lib/env';
import './styles/globals.css';

/**
 * Bootstrap.
 *
 * Cuando `VITE_USE_MOCKS=true` arrancamos MSW antes de renderizar la app
 * para que todas las llamadas `fetch('/api/*')` se intercepten con fixtures
 * in-memory y el frontend pueda ejercerse sin backend.
 *
 * Cuando `VITE_USE_MOCKS=false`, MSW nunca se carga y las llamadas van al
 * HTTP API Gateway real. Cognito autentica contra el User Pool del deploy.
 */
async function bootstrap() {
  if (env.useMocks) {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
    });
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </React.StrictMode>,
  );
}

if (import.meta.env.DEV) {
  void import('web-vitals').then(({ onCLS, onFCP, onINP, onLCP }) => {
    const log = (metric: { name: string; value: number; rating: string }) => {
      // eslint-disable-next-line no-console
      console.info(
        `[web-vitals] ${metric.name}: ${metric.value.toFixed(1)} (${metric.rating})`,
      );
    };
    onCLS(log);
    onFCP(log);
    onINP(log);
    onLCP(log);
  });
}

void bootstrap();
